const createContractData = contract => ({
  contract_type: contract.contract_type,
  shipping: contract.payment_info.shipping_method,
  dueDate: contract.payment_info.due_day,
  payment: contract.payment_info.payment_type,
  bank: contract.payment_info.automatic_debit?.bank,
  agency: contract.payment_info.automatic_debit?.agency,
  account: contract.payment_info.automatic_debit?.account
})

export default {
  fillOfflineContract({ commit }, contract) {
    commit("setContract", createContractData(contract))
  },
  fillContract({ commit }, contract) {
    commit("setContract", createContractData(contract))
  }
}
